import { gql } from "@apollo/client";

export const PAYMENT_MODES = gql`
  {
    paymentModes {
      paymentModeId
      paymentMode
    }
  }
`;
export const PARTNERS_FOR_PAYMENT_MODE_AND_FEES = gql`
  query ($operatorId: ID!) {
    partners(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;

export const PAYMENT_MODE_AND_FEES_BY_PARTNER_ID = gql`
  query ($operatorId: ID!, $partnerId: ID) {
    partners(operatorId: $operatorId, partnerId: $partnerId) {
      partnerCodPaymentFees {
        partnerCodPaymentFeeId
        paymentMode {
          paymentModeId
          paymentMode
        }
        codRate
      }
    }
  }
`;

// Mutations
export const ADD_PAYMENT_MODE = gql`
  mutation ($payments: [AddPaymentModeObject]!) {
    addPaymentMode(payments: $payments) {
      paymentModes {
        partnerCodPaymentFeeId
      }
    }
  }
`;

export const UPDATE_PAYMENT_MODE = gql`
  mutation ($payments: [UpdatePaymentModeObject]!) {
    updatePaymentMode(payments: $payments) {
      paymentModes {
        partnerCodPaymentFeeId
      }
    }
  }
`;
